import React from "react";
import { UserProvider } from "./user.context";
import { CurrencyProvider } from "./currency.context";
import { SnackbarProvider } from "./snackbar.context";

export const AppProviders = ({ children, msalInstance }) => {
  return (
    <UserProvider msalInstance={msalInstance}>
      <CurrencyProvider>
        <SnackbarProvider>
          {children}
        </SnackbarProvider>
      </CurrencyProvider>
    </UserProvider>
  );
};
